






import { Component, Vue } from "vue-property-decorator";
import { WorkshopGridCpt } from "./components";
import AppVue from "@/AppVue.vue";

@Component({
  components: {
    WorkshopGridCpt,
  },
})
export default class WorkshopsView extends AppVue {}
